/**
 * Social Listening — Learn-Mode inline tips.
 *
 * Covers `routes/social/Listening.tsx`. `social-listening-summary`,
 * `social-listening-queries` and `social-listening-feed` are passed as a
 * `helpContext` prop to the page's local `<Section>` wrapper (a dynamic
 * `data-help-context` spread), the other two are literal attributes.
 */

import type { LearnTip } from "./types";

export const listeningTips: LearnTip[] = [
  {
    key: "social-listening",
    title: "Listening",
    body: "Collects posts that talk about your clients outside their own feed: Bluesky posts that use the words you choose, Instagram posts that tag the client, and Instagram posts or comments that @mention them.",
    bullets: [
      "Bluesky is checked every 30 minutes, Instagram tags once a day.",
      "Instagram @mentions arrive as Instagram reports them.",
    ],
  },
  {
    key: "social-listening-summary",
    title: "Listening overview",
    body: 'How many mentions came in over the last 30 days, how many are still waiting for review, and how they split by source and tone. Tone is a quick automatic read of the wording; "Not sure" means it couldn\'t tell.',
  },
  {
    key: "social-listening-queries",
    title: "Listening queries",
    body: "Each query is a set of words or phrases plus the places to listen. Instagram tags and mentions need the client's Instagram connected with Facebook Login; Bluesky works without a connection.",
    bullets: [
      "Alerts: right away (at most hourly), a daily digest, or none. Alerts show counts only.",
      "A spike alert fires when a day is well above the usual (at least 5 mentions).",
      "Check now runs a query immediately — once every 10 minutes.",
    ],
  },
  {
    key: "social-listening-feed",
    title: "Mentions",
    body: "Every post or comment the queries found, newest first. Mark each one reviewed, actioned or ignored, and assign it to a teammate so nothing gets handled twice. Open post takes you to the original.",
  },
  {
    key: "social-listening-filters",
    title: "Mention filters",
    body: "Narrow the list by source, status, tone, query or a word in the post. “Tagged posts (UGC)” shows the Instagram posts other people tagged the client in, with a thumbnail — good material to reshare once you have their permission.",
  },
];
